/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgeniy Naumov
 * @version 1.23.0
 * @since 1.0.0
 */

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Title from '../../components/common/Title/Title';
import PageLocale from '../../modules/internationalization/components/PageLocale';
import { TranslationFileNamesEnum } from '../../modules/internationalization/constants';
import { IRootReducer } from '../../reducers/rootReducer';
import AuthCollapse from './components/AuthCollapse/AuthCollapse';
import AuthFormContainer from './components/AuthForm/AuthFormContainer';
import ChangePassword from './components/ChangePassword/ChangePassword';
import RecoveryFormContainer from './components/RecoveryForm/RecoveryFormContainer';
import { makeSelectLoggedIn } from './selectors/authSelectors';
import { PageAuthStyled } from './styled/PageAuthStyled';

export interface IPageAuthProps {
    type: 'auth' | 'recovery' | 'changePassword';
    changeLocale?: any;
}

interface IConnectedProps {
    loggedIn: boolean;
}

const getContent = (type: string) => {
    switch (type) {
        case 'auth':
            return <AuthFormContainer />;
        case 'recovery':
            return <RecoveryFormContainer />;
        case 'changePassword':
            return <ChangePassword />;
    }
};

const PageAuth = (props: IPageAuthProps & IConnectedProps) => {
    return (
        <PageAuthStyled className="page-auth__container" data-page-auth={props.type}>
            <PageLocale fileNames={[TranslationFileNamesEnum.pageAuth]}>
                <Title pageName="login" />
                {getContent(props.type)}
                <AuthCollapse />
            </PageLocale>
        </PageAuthStyled>
    );
};

const mapStateToProps = createStructuredSelector<IRootReducer, IPageAuthProps, IConnectedProps>({
    loggedIn: makeSelectLoggedIn(),
});

export default connect(mapStateToProps)(PageAuth);
